import { render, staticRenderFns } from "./stockOtherRecord.vue?vue&type=template&id=88da527a&scoped=true"
import script from "./stockOtherRecord.vue?vue&type=script&lang=js"
export * from "./stockOtherRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88da527a",
  null
  
)

export default component.exports